export const isString = <T>(value: T | string): value is string => typeof value === 'string' || value instanceof String;

export const notUndefined = <T>(value: T | undefined): value is T => value !== undefined;
